import React from 'react'
import { UserActionRequiredErrorDto } from '../../dto'
import { WarningTile, WarningBanner } from '../messages'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getTranslationBasedOnUserActionRequiredErrorCodes } from '../../functions'

interface Props {
  userActionRequiredError: UserActionRequiredErrorDto[]
  showAllErrors: boolean
}

/**
 * Displays a tile indicating that user action is required for vehicle errors.
 */
const UserActionRequiredTile: React.FC<Props> = ({ userActionRequiredError, showAllErrors = false }) => {
  const { t } = useCustomTranslation()

  const errorTranslations = getTranslationBasedOnUserActionRequiredErrorCodes(userActionRequiredError)

  if (showAllErrors) {
    return <WarningBanner errors={errorTranslations} />
  }

  if (errorTranslations.length === 1) {
    return <WarningTile title={t(errorTranslations[0].title)} message={t(errorTranslations[0].message)} />
  }

  return (
    <WarningTile
      title={t('vehicle-integration.vehicles.multiple-user-action-needed-title')}
      message={t('vehicle-integration.vehicles.multiple-user-action-needed-message')}
    />
  )
}

export default UserActionRequiredTile
